export const WA_NUMBER = "552120184446";
export const WA_DISPLAY = "(21) 2018-4446";

export const waLink = (msg) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

const clean = (s) => String(s || "").replace(/\s+/g, " ").trim();

export const WA_DEFAULT =
  "Olá! Encontrei a Bella Film RJ pelo site e gostaria de solicitar um orçamento de insulfilm.";

export const waService = (service) =>
  `Olá! Encontrei a Bella Film RJ pelo site e gostaria de solicitar um orçamento de ${clean(service)}.`;

export const waProduct = (product) =>
  `Olá! Vi a película ${clean(product)} no catálogo da Bella Film RJ e gostaria de solicitar um orçamento.`;
